import { render } from "./ResultComponent.vue?vue&type=template&id=45e59e9b"
import script from "./ResultComponent.vue?vue&type=script&lang=js"
export * from "./ResultComponent.vue?vue&type=script&lang=js"

import "./ResultComponent.vue?vue&type=style&index=0&id=45e59e9b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__